import { fromPairs } from "ramda";
import { productsCatalogActions } from "./products/actions";
import { product_groupsCatalogActions } from "./product_groups/actions";
import { releasesCatalogActions } from "./releases/actions";
import { tracksCatalogActions } from "./tracks/actions";
import { artistsCatalogActions } from "./artists/actions";
import { labelsCatalogActions } from "./labels/actions";
import { CatalogModulePluginStore } from "./plugin-store";
import { projectsCatalogActions } from "./projects/actions";

export const actions = {
  ...productsCatalogActions,
  ...releasesCatalogActions,
  ...product_groupsCatalogActions,
  ...tracksCatalogActions,
  ...artistsCatalogActions,
  ...labelsCatalogActions,
  ...projectsCatalogActions,
  ...CatalogModulePluginStore.actions
};
